
import { Component, Inject, Vue, Emit, Ref, Prop, Watch } from "vue-property-decorator";
import { Container } from "inversify";
import { Conference } from "@gsx/common";
import { Coordinates } from "@gsx/common";
import { OrganizationListItem } from "@gsx/common/src/types/http/dashboard/organization";
import { ConferenceListItem } from "@gsx/common/src/types/http/dashboard/conference";

@Component({
    components: {},
})
export default class UserDashboardMap extends Vue {
    @Inject("container") container!: Container;
    @Ref("map") readonly map!: HTMLDivElement;
    @Prop() events!: ConferenceListItem[];
    @Prop() orgs!: OrganizationListItem[];
    showEvents = true;
    showOrgs = true;

    mounted() {
        // @ts-ignore
        $(this.map).vectorMap({
            map: "world_mill_en",
            normalizeFunction: "polynomial",
            zoomMax: 200,
            zoomStep: 2,
            zoomAnimate: false,
            hoverOpacity: 0.7,
            hoverColor: false,
            regionStyle: {
                initial: {
                    fill: "#e3eaef",
                },
                hover: {
                    fill: "#e69334",
                },
            },
            markerStyle: {
                initial: {
                    r: 9,
                    fill: "#727cf5",
                    "fill-opacity": 0.9,
                    stroke: "#fff",
                    "stroke-width": 7,
                    "stroke-opacity": 0.4,
                },
                hover: {
                    fill: "#e69334",
                    r: 8,
                    stroke: "#fff",
                    "fill-opacity": 1,
                    "stroke-width": 1.5,
                },
                selected: {
                    r: 15,
                    fill: "#e69334",
                    stroke: "#fff",
                },
                selectedHover: {
                    fill: "#e69334",
                    r: 8,
                    stroke: "#fff",
                    "fill-opacity": 1,
                    "stroke-width": 1.5,
                },
            },
            backgroundColor: "transparent",
            onMarkerClick: (_e: any, code: string) => {
                if (this.events.find((event) => event.conferenceid === code)) {
                    this.handleEventClick(code);
                } else {
                    this.$router.push(`/organizations/${code}`);
                }
            },
        });

        this.updateMapMarkers();
    }

    beforeDestroy() {
        this.getMapObject().remove();
    }

    @Watch("showEvents")
    @Watch("showOrgs")
    @Watch("orgs")
    @Watch("events")
    updateMapMarkers() {
        let mapObject = this.getMapObject();

        if (!mapObject) {
            return;
        }

        mapObject.removeAllMarkers();

        if (this.showEvents) {
            let eventsToShow = this.events;

            eventsToShow.forEach((event) => {
                if (
                    event.coordinates &&
                    event.coordinates.latitude &&
                    event.coordinates.longitude
                ) {
                    mapObject.addMarker(
                        `${event.conferenceid}`,
                        this.createEventLocation(event, event.coordinates, "black"),
                    );
                }
            });
        }

        if (this.showOrgs) {
            let orgsToShow = this.orgs;
            orgsToShow.forEach((org) => {
                if (org.coordinates && org.coordinates.latitude && org.coordinates.longitude) {
                    mapObject.addMarker(
                        `${org.organizationid}`,
                        this.createOrgLocation(org, org.coordinates, "blue"),
                    );
                }
            });
        }
    }

    createEventLocation(
        conference: Conference,
        coordinates: Coordinates | null | undefined,
        color: string,
    ) {
        return {
            latLng: [coordinates!.latitude, coordinates!.longitude],
            name: conference.name,
            style: {
                r: 8,
                fill: color,
            },
        };
    }

    createOrgLocation(
        organization: OrganizationListItem,
        coordinates: Coordinates | null | undefined,
        color: string,
    ) {
        return {
            latLng: [coordinates!.latitude, coordinates!.longitude],
            name: organization.organizationName,
            style: {
                r: 8,
                fill: color,
            },
        };
    }

    @Emit("eventClick")
    handleEventClick(eventId: any) {
        return { event: { id: eventId } };
    }

    getMapObject() {
        return $(this.map).find(".jvectormap-container").data("mapObject");
    }
}
